module.exports = __webpack_public_path__ + "img/historia16.477acac9.jpg";